import "./DollhouseDecor.css";

/**
 * Hand-drawn style line-art dollhouse. Purely decorative — parents set
 * size/position via the className; colors inherit the paper palette.
 */
const House = ({ className }) => (
  <svg
    className={`dollhouse ${className || ""}`}
    viewBox="0 0 120 130"
    fill="none"
    aria-hidden="true"
  >
    {/* chimney */}
    <path d="M88 18 v-12 h10 v22" className="dh-line" />
    <path d="M86 6 h14" className="dh-line" />
    {/* roof */}
    <path d="M10 62 L60 12 L110 62" className="dh-line dh-roof" />
    {/* body */}
    <path d="M20 60 v58 h80 v-58" className="dh-line" />
    <path d="M14 118 h92" className="dh-line" />
    {/* floor divider — dollhouse rooms */}
    <path d="M20 90 h80" className="dh-line dh-thin" />
    <path d="M60 90 v28" className="dh-line dh-thin" />
    {/* attic heart */}
    <path
      d="M60 50 c-2.5-5 -10-5 -10 1 c0 4 5 7 10 11 c5-4 10-7 10-11 c0-6 -7.5-6 -10-1 z"
      className="dh-heart"
    />
    {/* windows with a soft glow */}
    <rect x="30" y="68" width="16" height="14" rx="2" className="dh-window" />
    <rect x="74" y="68" width="16" height="14" rx="2" className="dh-window" />
    <rect x="30" y="96" width="16" height="14" rx="2" className="dh-window dh-window-late" />
    {/* door */}
    <path d="M70 118 v-16 a8 8 0 0 1 16 0 v16" className="dh-line" />
    <circle cx="83" cy="108" r="1.6" className="dh-dot" />
  </svg>
);

/**
 * Decorative clusters of floating dollhouses for the empty space beside
 * the form on wide screens. Hidden on small screens and inert for a11y.
 */
const DollhouseDecor = () => (
  <>
    <div className="dollhouse-decor decor-left" aria-hidden="true">
      <House className="dh-lg float-a" />
      <House className="dh-sm float-b" />
      <House className="dh-md float-c" />
      <House className="dh-xs float-b" />
    </div>
    <div className="dollhouse-decor decor-right" aria-hidden="true">
      <House className="dh-md float-c" />
      <House className="dh-xs float-a" />
      <House className="dh-lg float-b" />
      <House className="dh-sm float-a" />
    </div>
  </>
);

/**
 * Faint watermark houses scattered behind the message wall (wide screens).
 */
export const DollhouseBackdrop = () => (
  <div className="dollhouse-backdrop" aria-hidden="true">
    <House className="dh-md backdrop-house bh-1 float-a" />
    <House className="dh-sm backdrop-house bh-2 float-b" />
    <House className="dh-lg backdrop-house bh-3 float-c" />
    <House className="dh-sm backdrop-house bh-4 float-a" />
  </div>
);

/**
 * A little village skyline above the footer — all screen sizes.
 */
export const DollhouseVillage = () => (
  <div className="dollhouse-village" aria-hidden="true">
    <House className="dh-village v-1 float-b" />
    <House className="dh-village v-2 float-a" />
    <House className="dh-village v-3 float-c" />
    <House className="dh-village v-4 float-a" />
    <House className="dh-village v-5 float-b" />
    <House className="dh-village v-6 float-c" />
    <House className="dh-village v-7 float-a" />
  </div>
);

export default DollhouseDecor;
